export const STATS_ELEMENT_SIMPLE_GRID_VIEW_TRIGGER_PAST_YEARS = 5;
